module.exports = __webpack_public_path__ + "static/media/sparkasse-rastatt.d238988e.jpg";